import Footer from "@/components/Footer";

import Layout from "@/components/Layout";
import Image from "next/image";

import React, { useEffect, useState } from "react";
import { useWholesalePage } from "@/hooks/pages";
import Loading from "@/components/Loading";

const Wholesale = () => {
  const { page, loading } = useWholesalePage();

  if (loading) return <Loading />;

  // Extract the image URL from the body field
  const imageRegex = /<img[^>]+src="([^">]+)"/g;
  const imageMatches = imageRegex.exec(page?.body);
  const imageUrl =
    imageMatches && imageMatches.length > 1 ? imageMatches[1] : null;

  // Extract the h1 tag from the body field
  const h1Regex = /<h1[^>]*>([^<]+)<\/h1>/i;
  const h1Matches = h1Regex.exec(page?.body);
  const pageTitle = h1Matches && h1Matches.length > 1 ? h1Matches[1] : "";

  // Extract the h1 tag from the body field
  const h4Regex = /<h4[^>]*>([^<]+)<\/h4>/i;
  const h4Matches = h4Regex.exec(page?.body);
  const pageEndTitle = h4Matches && h4Matches.length > 1 ? h4Matches[1] : "";

  // Extract the <p> tags
  const pRegex = /<p\b[^>]*>([\s\S]*?)<\/p>/g;
  const pMatches = page.body.match(pRegex);
  const extractedParagraphs = pMatches
    ? pMatches.map((match) =>
        match.replace(/<\/?p[^>]*>/g, "").replace(/<img[^>]*>/g, "")
      ) // Remove img tags)
    : [];

  // Extract the <a> tag
  const aRegex = /<a\b[^>]*>([\s\S]*?)<\/a>/;
  const aMatch = page.body.match(aRegex);
  const extractedLink = aMatch ? aMatch[1] : "";

  // Extract the <h2> tag
  const h2Regex = /<h2\b[^>]*>([\s\S]*?)<\/h2>/;
  const h2Match = page.body.match(h2Regex);
  const extractedH2 = h2Match ? h2Match[1] : "";

  return (
    <>
      {/* second */}
      <div className=" w-full h-auto pb-6">
        <div className="flex lg:flex-row flex-col items-start justify-between bg-[#F4F8FF] h-auto w-screen py-8 px-4">
          <div className=" space-y-8 py-8 w-full lg:w-[60%] px-2 lg:px-28 flex flex-col items-start justify-center">
            {/* typography */}
            <div>
              <h1 className="text-[#294870] text-4xl lg:text-5xl font-bold">
                {pageTitle && <h1>{pageTitle}</h1>}
              </h1>
            </div>
            {extractedParagraphs &&
              extractedParagraphs.map((item, key) => (
                <p key={key} className="text-sm w-[90%] lg:w-[87%]">
                  {item}
                </p>
              ))}

            <button className="font-medium hover:bg-[#355b8d] bg-[#294870] text-white px-8 py-2 rounded-[31px]">
              <div
                className="dangerousHTML"
                dangerouslySetInnerHTML={{
                  __html: extractedH2,
                }}
              ></div>
            </button>
            <p className="italic">{pageEndTitle}</p>
          </div>
          <div className=" flex items-center justify-center w-full lg:w-[40%]">
            <div className="flex items-center justify-center lg:w-[100%] h-auto relative">
              {imageUrl && (
                <Image
                  src={imageUrl}
                  width={600}
                  height={600}
                  alt="hero section sloth image"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <Layout>
        <div className=" w-full h-auto py-6 space-y-8 ">
          <div className="space-y-2 w-full text-center">
            <h2 className="text-5xl font-semibold text-[#355b8d]">
              Inquire Here
            </h2>
            <p className="text-sm"> Alternatively, use the below form:</p>
          </div>

          <div className="flex justify-center items-center">
            <form
              action="https://api.web3forms.com/submit"
              method="POST"
              className="space-y-4 w-full lg:w-[80%]"
            >
              <input
                type="hidden"
                name="access_key"
                value="e8aa6e68-a56e-415d-ba34-0e25db24a8a6"
              />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="hidden space-y-2 ">
                  <label
                    className="text-[#1E1E1E] text-sm px-1"
                    htmlFor="email"
                  >
                    Form Name
                  </label>
                  <input
                    className="w-full rounded-lg bg-[#EFEFEF] outline-none p-4 text-sm"
                    type="text"
                    name="formName"
                    value="Wholesale Page's Form"
                  />
                </div>
                <div className="space-y-2 ">
                  <label
                    className="text-[#1E1E1E] text-sm px-1"
                    htmlFor="email"
                  >
                    Name
                  </label>
                  <input
                    className="w-full rounded-lg bg-[#EFEFEF] outline-none p-4 text-sm"
                    type="text"
                    name="name"
                    required
                  />
                </div>
                <div className="space-y-2 ">
                  <label
                    className="text-[#1E1E1E] text-sm px-1"
                    htmlFor="email"
                  >
                    Email
                  </label>
                  <input
                    className="w-full rounded-lg bg-[#EFEFEF] outline-none p-4 text-sm"
                    type="email"
                    name="email"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="space-y-2 ">
                  <label
                    className="text-[#1E1E1E] text-sm px-1"
                    htmlFor="company"
                  >
                    Company
                  </label>
                  <input
                    className="w-full rounded-lg bg-[#EFEFEF] outline-none p-4 text-sm"
                    type="text"
                    name="company"
                  />
                </div>
                <div className="space-y-2 ">
                  <label
                    className="text-[#1E1E1E] text-sm px-1"
                    htmlFor="phone"
                  >
                    Phone
                  </label>
                  <input
                    className="w-full rounded-lg bg-[#EFEFEF] outline-none p-4 text-sm"
                    type="tel"
                    name="phone"
                    required
                  />
                </div>
              </div>

              <div className="space-y-2 ">
                <label
                  className="text-[#1E1E1E] text-sm px-1"
                  htmlFor="message"
                >
                  Message
                </label>
                <textarea
                  className="w-full rounded-lg bg-[#EFEFEF] outline-none p-4 text-sm"
                  rows={6}
                  name="message"
                  required
                  defaultValue={""}
                />
              </div>

              <input
                type="hidden"
                name="redirect"
                value="https://web3forms.com/success"
              />
              <div className="mt-4">
                <button
                  type="submit"
                  className=" hover:bg-[#355b8d] bg-[#294870] text-white px-8 py-2 rounded-[31px]"
                >
                  SEND
                </button>
              </div>
            </form>
          </div>
        </div>
      </Layout>

      <Footer />
    </>
  );
};

export default Wholesale;
